module.exports = __webpack_public_path__ + "img/95.5b68bc98.png";